import { Component, EventEmitter, Input, Output } from '@angular/core';
import { OdbCoverDetailDivision } from '@dch/billing-business-logic';
import { ICategoryClickEvent } from './cover-details-division.component';

@Component({
  selector: 'my-bill-odb-cover-details-divisions',
  templateUrl: './odb-cover-details-divisions.component.html',
  standalone: false,
})
export class OdbCoverDetailsDivisionsComponent {
  @Input() divisions: OdbCoverDetailDivision[];
  @Input() testIDPrefix: string;
  @Input() firstIdentifierHasClassRsTit4 = true;
  @Output() categoryClick = new EventEmitter<ICategoryClickEvent>();
}
